import { IRequisitionListFilters, IRequisitionListResponse, ILookupItem } from './forms.types';

import {
  IRequisitionDetailResponse,
  IRequisitionSavePayload,
} from './forms.models';

import {
  IReviewQueueFilters,
  IReviewQueueResponse,
  IReviewWorkspaceResponse,
  IReviewItemRecord,
  IClassificationSuggestionResponse,
} from './review.models';

import {
  IAnalyticsAiVsManual,
  IAnalyticsByCostCenterItem,
  IAnalyticsByResourceTypeItem,
  IAnalyticsByStateItem,
  IAnalyticsSummary,
  IFormsAnalyticsFilters,
} from './analytics.models';

import { bizpost } from '../../../ajax';


interface IApiEnvelope<T> {
  ok: boolean;
  message?: string;
  data: T;
  errors?: Array<{
    field?: string;
    code?: string;
    message: string;
  }>;
  warnings?: Array<{
    field?: string;
    code?: string;
    message: string;
  }>;
}

function buildQuery(params: Record<string, string | number | undefined>): string {
  const searchParams = new URLSearchParams();

  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null && `${value}`.trim() !== '') {
      searchParams.append(key, `${value}`);
    }
  });

  const query = searchParams.toString();
  return query ? `?${query}` : '';
}

async function getJson<T>(url: string): Promise<T> {
  const response = await fetch(`/biz${url}`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const payload = await response.json();
  return payload as T;
}

export async function fetchRequisitions(
  filters: IRequisitionListFilters
): Promise<IRequisitionListResponse> {
  const query = buildQuery({
    search: filters.search,
    periodix: filters.periodix,
    cycleix: filters.cycleix,
    costcenterix: filters.costcenterix,
    stateix: filters.stateix,
    aiassisted: filters.aiassisted,
    fromdate: filters.fromdate,
    todate: filters.todate,
    page: filters.page,
    pagesize: filters.pagesize,
  });

  const payload = await getJson<IApiEnvelope<IRequisitionListResponse>>(
    `/api/forms/requisitions${query}`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load requisitions');
  }

  return payload.data;
}

export const fetchRequisitions1 = async (filters: IRequisitionListFilters): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      bpi: filters.periodix,
      bci: filters.cycleix,
      cci: filters.costcenterix,
      ssi: filters.stateix,
      aia: filters.aiassisted,
      fdt: filters.fromdate,
      tdt: filters.todate,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchBudgetPeriods(): Promise<ILookupItem[]> {
  const payload = await getJson<IApiEnvelope<{ items: ILookupItem[] }>>(
    `/api/budget/periods`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load periods');
  }

  return payload.data.items || [];
}

export const fetchBudgetPeriods1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchBudgetCycles(): Promise<ILookupItem[]> {
  const payload = await getJson<IApiEnvelope<{ items: ILookupItem[] }>>(
    `/api/budget/cycles`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load cycles');
  }

  return payload.data.items || [];
}

export const fetchBudgetCycles1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchCostCenters(): Promise<ILookupItem[]> {
  const payload = await getJson<IApiEnvelope<{ items: ILookupItem[] }>>(
    `/api/finance/costcenters`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load cost centers');
  }

  return payload.data.items || [];
}

// export const fetchCostCenters1 = async (filters: any): Promise<any> => {
//   let rtn:any;
//   try{
//     const params = {
//       qry: filters.search,
//       pos: filters.page,
//       plm: filters.pagesize,
//     };

//     const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
//     const response = await bizpost(baseparams);

//     const {success:ok,sd:items,rc:total} = response;

//     rtn = response;
//   }
//   catch(err){
//     throw new Error('Request failed '+err);
//   }

//   return rtn;
// }

export async function fetchRequisitionStates(): Promise<ILookupItem[]> {
  const payload = await getJson<IApiEnvelope<{ items: ILookupItem[] }>>(
    `/api/forms/requisitionstates`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load requisition states');
  }

  return payload.data.items || [];
}

// export const fetchRequisitionStates1 = async (filters: any): Promise<any> => {
//   let rtn:any;
//   try{
//     const params = {
//       qry: filters.search,
//       pos: filters.page,
//       plm: filters.pagesize,
//     };

//     const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
//     const response = await bizpost(baseparams);

//     const {success:ok,sd:items,rc:total} = response;

//     rtn = response;
//   }
//   catch(err){
//     throw new Error('Request failed '+err);
//   }

//   return rtn;
// }

/////////////////////////////



interface IApiEnvelope<T> {
  ok: boolean;
  message?: string;
  data: T;
  errors?: Array<{
    field?: string;
    code?: string;
    message: string;
  }>;
  warnings?: Array<{
    field?: string;
    code?: string;
    message: string;
  }>;
}

async function sendJson<T>(url: string, method: 'POST' | 'PUT', body: any): Promise<T> {
  const response = await fetch(`/biz${url}`, {
    method,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  return (await response.json()) as T;
}

export async function fetchRequisitionDetail(
  requisitionix: string
): Promise<IRequisitionDetailResponse> {
  const payload = await getJson<IApiEnvelope<IRequisitionDetailResponse>>(
    `/api/forms/requisitions/${requisitionix}`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load requisition');
  }

  return payload.data;
}

export const fetchRequisitionDetail1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function createRequisition(
  payloadBody: IRequisitionSavePayload
): Promise<any> {
  const payload = await sendJson<IApiEnvelope<any>>(
    `/api/forms/requisitions`,
    'POST',
    payloadBody
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to create requisition');
  }

  return payload.data;
}

export const createRequisition1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function updateRequisition(
  requisitionix: string,
  payloadBody: IRequisitionSavePayload
): Promise<any> {
  const payload = await sendJson<IApiEnvelope<any>>(
    `/api/forms/requisitions/${requisitionix}`,
    'PUT',
    payloadBody
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to update requisition');
  }

  return payload.data;
}

export const updateRequisition1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchRequisitionTypes(): Promise<ILookupItem[]> {
  const payload = await getJson<IApiEnvelope<{ items: ILookupItem[] }>>(
    `/api/forms/requisitiontypes`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load requisition types');
  }

  return payload.data.items || [];
}

export const fetchRequisitionTypes1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchResourceTypes(): Promise<ILookupItem[]> {
  const payload = await getJson<IApiEnvelope<{ items: ILookupItem[] }>>(
    `/api/forms/resourcetypes`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load resource types');
  }

  return payload.data.items || [];
}

export const fetchResourceTypes1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchPriorities(): Promise<ILookupItem[]> {
  const payload = await getJson<IApiEnvelope<{ items: ILookupItem[] }>>(
    `/api/forms/priorities`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load priorities');
  }

  return payload.data.items || [];
}

export const fetchPriorities1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchUoms(): Promise<ILookupItem[]> {
  const payload = await getJson<IApiEnvelope<{ items: ILookupItem[] }>>(
    `/api/forms/uoms`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load UOMs');
  }

  return payload.data.items || [];
}

export const fetchUoms1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

////////////////////

export interface IAiDraftResponse {
  draft: {
    requisition: {
      recname: string;
      shortcode: string | null;
      description: string;
      typeix?: string;
      typecode?: string | null;
      periodix?: string;
      periodcode?: string | null;
      cycleix?: string;
      cyclecode?: string | null;
      costcenterix?: string;
      costcentercode?: string | null;
      reference: string | null;
      purpose: string;
      requesteddate: string | null;
      neededfrom: string | null;
      neededto: string | null;
      totalestimate: number | null;
      aiassisted: number;
      rawinput: string;
    };
    items: Array<{
      lineno: number;
      recname: string;
      shortcode: string | null;
      description: string;
      typeix?: string;
      typecode?: string | null;
      quantity: number | null;
      uomix?: string;
      uomcode?: string | null;
      unitestimate: number | null;
      totalestimate: number | null;
      neededfrom: string | null;
      neededto: string | null;
      justification: string;
      expectedoutcome: string | null;
      technicalspec: string | null;
      priorityix?: string;
      prioritycode?: string | null;
      kpinote: string | null;
    }>;
    assumptions: string[];
    clarifications: string[];
  };
  meta?: {
    promptix?: string;
    modelname?: string;
    confidencevalue?: number;
  };
}

export async function generateAiDraft(payloadBody: {
  rawinput: string;
  typeix?: string;
  periodix?: string;
  cycleix?: string;
  costcenterix?: string;
  promptix?: string;
}): Promise<IAiDraftResponse> {
  const payload = await sendJson<IApiEnvelope<IAiDraftResponse>>(
    `/api/forms/requisitions/aidraft`,
    'POST',
    payloadBody
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to generate AI draft');
  }

  return payload.data;
}

export const generateAiDraft1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function refineAiDraft(payloadBody: {
  draft: any;
  instruction: string;
}): Promise<IAiDraftResponse> {
  const payload = await sendJson<IApiEnvelope<IAiDraftResponse>>(
    `/api/forms/requisitions/airefine`,
    'POST',
    payloadBody
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to refine AI draft');
  }

  return payload.data;
}

export const refineAiDraft1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchPrompts(): Promise<ILookupItem[]> {
  const payload = await getJson<IApiEnvelope<{ items: ILookupItem[] }>>(
    `/api/forms/prompts`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load prompts');
  }

  return payload.data.items || [];
}

export const fetchPrompts1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}


////////////////////////



export async function fetchReviewQueue(
  filters: IReviewQueueFilters
): Promise<IReviewQueueResponse> {
  const query = buildQuery({
    search: filters.search,
    periodix: filters.periodix,
    costcenterix: filters.costcenterix,
    stateix: filters.stateix,
    page: filters.page,
    pagesize: filters.pagesize,
  });

  const payload = await getJson<IApiEnvelope<IReviewQueueResponse>>(
    `/api/forms/reviews/queue${query}`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load review queue');
  }

  return payload.data;
}

export const fetchReviewQueue1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchRequisitionReview(
  requisitionix: string
): Promise<IReviewWorkspaceResponse> {
  const payload = await getJson<IApiEnvelope<IReviewWorkspaceResponse>>(
    `/api/forms/requisitions/${requisitionix}/review`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load requisition review');
  }

  return payload.data;
}

export const fetchRequisitionReview1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function saveItemReview(
  itemix: string,
  payloadBody: IReviewItemRecord
): Promise<any> {
  const payload = await sendJson<IApiEnvelope<any>>(
    `/api/forms/requisitionitems/${itemix}/review`,
    'POST',
    payloadBody
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to save item review');
  }

  return payload.data;
}

export const saveItemReview1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function saveBulkReview(
  requisitionix: string,
  payloadBody: { items: IReviewItemRecord[] }
): Promise<any> {
  const payload = await sendJson<IApiEnvelope<any>>(
    `/api/forms/requisitions/${requisitionix}/review/bulk`,
    'POST',
    payloadBody
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to save bulk review');
  }

  return payload.data;
}

export const saveBulkReview1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function completeReview(
  requisitionix: string,
  payloadBody?: { remarks?: string }
): Promise<any> {
  const payload = await sendJson<IApiEnvelope<any>>(
    `/api/forms/requisitions/${requisitionix}/review/complete`,
    'POST',
    payloadBody || {}
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to complete review');
  }

  return payload.data;
}

export const completeReview1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchReviewStates(): Promise<ILookupItem[]> {
  const payload = await getJson<IApiEnvelope<{ items: ILookupItem[] }>>(
    `/api/forms/reviewstates`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load review states');
  }

  return payload.data.items || [];
}

export const fetchReviewStates1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchChartOfAccounts(): Promise<ILookupItem[]> {
  const payload = await getJson<IApiEnvelope<{ items: ILookupItem[] }>>(
    `/api/finance/chartofaccounts`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load chart of accounts');
  }

  return payload.data.items || [];
}

export const fetchChartOfAccounts1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

/////////////////////


export interface IApprovalQueueItem {
  recix: string;
  reference: string;
  recname: string;
  description: string;
  requesteddate: string | null;
  totalestimate: number;
  reviewedtotal: number;
  approvedtotal?: number;
  itemcount: number;
  reviewedcount: number;
  stamp: string | null;

  period?: ILookupItem | null;
  cycle?: ILookupItem | null;
  costcenter?: ILookupItem | null;
  staff?: ILookupItem | null;
  state?: ILookupItem | null;
}

export interface IApprovalQueueResponse {
  items: IApprovalQueueItem[];
  page: number;
  pagesize: number;
  total: number;
}

export interface IApprovalQueueFilters {
  search: string;
  periodix: string;
  costcenterix: string;
  stateix: string;
  page: number;
  pagesize: number;
}

export async function fetchApprovalQueue(
  filters: IApprovalQueueFilters
): Promise<IApprovalQueueResponse> {
  const query = buildQuery({
    search: filters.search,
    periodix: filters.periodix,
    costcenterix: filters.costcenterix,
    stateix: filters.stateix,
    page: filters.page,
    pagesize: filters.pagesize,
  });

  const payload = await getJson<IApiEnvelope<IApprovalQueueResponse>>(
    `/api/forms/approvals/queue${query}`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load approvals queue');
  }

  return payload.data;
}

export const fetchApprovalQueue1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function approveRequisition(
  requisitionix: string,
  payloadBody?: { remarks?: string }
): Promise<any> {
  const payload = await sendJson<IApiEnvelope<any>>(
    `/api/forms/requisitions/${requisitionix}/approve`,
    'POST',
    payloadBody || {}
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to approve requisition');
  }

  return payload.data;
}

export const approveRequisition1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function rejectRequisition(
  requisitionix: string,
  payloadBody?: { remarks?: string }
): Promise<any> {
  const payload = await sendJson<IApiEnvelope<any>>(
    `/api/forms/requisitions/${requisitionix}/reject`,
    'POST',
    payloadBody || {}
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to reject requisition');
  }

  return payload.data;
}

export const rejectRequisition1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function returnRequisition(
  requisitionix: string,
  payloadBody?: { remarks?: string }
): Promise<any> {
  const payload = await sendJson<IApiEnvelope<any>>(
    `/api/forms/requisitions/${requisitionix}/return`,
    'POST',
    payloadBody || {}
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to return requisition');
  }

  return payload.data;
}

export const returnRequisition1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}


///////////////



export async function fetchAnalyticsSummary(
  filters: IFormsAnalyticsFilters
): Promise<IAnalyticsSummary> {
  const query = buildQuery({
    periodix: filters.periodix,
    costcenterix: filters.costcenterix,
    fromdate: filters.fromdate,
    todate: filters.todate,
  });

  const payload = await getJson<IApiEnvelope<IAnalyticsSummary>>(
    `/api/forms/analytics/summary${query}`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load analytics summary');
  }

  return payload.data;
}

export const fetchAnalyticsSummary1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchAnalyticsByState(
  filters: IFormsAnalyticsFilters
): Promise<IAnalyticsByStateItem[]> {
  const query = buildQuery({
    periodix: filters.periodix,
    costcenterix: filters.costcenterix,
    fromdate: filters.fromdate,
    todate: filters.todate,
  });

  const payload = await getJson<IApiEnvelope<{ items: IAnalyticsByStateItem[] }>>(
    `/api/forms/analytics/by-state${query}`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load analytics by state');
  }

  return payload.data.items || [];
}

export const fetchAnalyticsByState1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchAnalyticsByCostCenter(
  filters: IFormsAnalyticsFilters
): Promise<IAnalyticsByCostCenterItem[]> {
  const query = buildQuery({
    periodix: filters.periodix,
    costcenterix: filters.costcenterix,
    fromdate: filters.fromdate,
    todate: filters.todate,
  });

  const payload = await getJson<IApiEnvelope<{ items: IAnalyticsByCostCenterItem[] }>>(
    `/api/forms/analytics/by-costcenter${query}`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load analytics by cost center');
  }

  return payload.data.items || [];
}

export const fetchAnalyticsByCostCenter1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchAnalyticsByResourceType(
  filters: IFormsAnalyticsFilters
): Promise<IAnalyticsByResourceTypeItem[]> {
  const query = buildQuery({
    periodix: filters.periodix,
    costcenterix: filters.costcenterix,
    fromdate: filters.fromdate,
    todate: filters.todate,
  });

  const payload = await getJson<IApiEnvelope<{ items: IAnalyticsByResourceTypeItem[] }>>(
    `/api/forms/analytics/by-resourcetype${query}`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load analytics by resource type');
  }

  return payload.data.items || [];
}

export const fetchAnalyticsByResourceType1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

export async function fetchAnalyticsAiVsManual(
  filters: IFormsAnalyticsFilters
): Promise<IAnalyticsAiVsManual> {
  const query = buildQuery({
    periodix: filters.periodix,
    costcenterix: filters.costcenterix,
    fromdate: filters.fromdate,
    todate: filters.todate,
  });

  const payload = await getJson<IApiEnvelope<IAnalyticsAiVsManual>>(
    `/api/forms/analytics/ai-vs-manual${query}`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load AI vs manual analytics');
  }

  return payload.data;
}

export const fetchAnalyticsAiVsManual1 = async (filters: any): Promise<any> => {
  let rtn:any;
  try{
    const params = {
      qry: filters.search,
      pos: filters.page,
      plm: filters.pagesize,
    };

    const baseparams = { s:'requisition', a:'find', ...params}; /*shc:code,/*,pos:pos,plm:plm*/
    const response = await bizpost(baseparams);

    const {success:ok,sd:items,rc:total} = response;

    rtn = response;
  }
  catch(err){
    throw new Error('Request failed '+err);
  }

  return rtn;
}

///////////// classification ///////////////

export async function classifyRequisitionItems(payloadBody: {
  items: Array<{
    itemix?: string;
    recname: string | null;
    description: string | null;
    justification: string | null;
    expectedoutcome: string | null;
    technicalspec: string | null;
    kpinote: string | null;
    quantity: number | null;
    unitestimate: number | null;
    totalestimate: number | null;
    typecode: string | null;
    prioritycode: string | null;
    header?: {
      periodcode?: string | null;
      cyclecode?: string | null;
      costcentercode?: string | null;
      requisitiontypecode?: string | null;
      purpose?: string | null;
    };
  }>;
}): Promise<IClassificationSuggestionResponse> {
  const payload = await sendJson<IApiEnvelope<IClassificationSuggestionResponse>>(
    `/api/forms/requisitions/aiclassify`,
    'POST',
    payloadBody
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to generate classification suggestions');
  }

  return payload.data;
}

///////////// activity ABB ////////////////

export async function fetchActivities(): Promise<ILookupItem[]> {
  const payload = await getJson<IApiEnvelope<{ items: ILookupItem[] }>>(
    `/api/activity/activities`
  );

  if (!payload.ok) {
    throw new Error(payload.message || 'Failed to load activities');
  }

  return payload.data.items || [];
}

